// @ts-strict-ignore
import { Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ProjectNavigationModel } from '../project-navigation.model';
import { ProjectNavigationService } from '../service/project-navigation.service';
import { UserSettings } from '@user/model/user-settings';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { MultipleQuoteRequestData } from '@project/components/request/multiple-quote-request-data';
import { ProjectComponentPresenter } from '@project/components/project-component.presenter';

@Component({
  standalone: false,
  selector: 'app-request-multiple-quote',
  templateUrl: './request-multiple-quote.component.html'
})
export class RequestMultipleQuoteComponent implements OnDestroy, OnInit {
  @Input() isCompositeArticleProject: boolean;

  @Output() public finish = new EventEmitter<void>();

  @HostBinding(`class.d-flex`) displayFlexClass = true;
  @HostBinding(`class.flex-column`) flexDirectionClass = true;

  public model: ProjectNavigationModel;

  public submitEnabled = false;

  public constructor(
    private projectNavigationService: ProjectNavigationService,
    private userSettings: UserSettings,
    private projectComponentPresenter: ProjectComponentPresenter,
  ) {}

  public ngOnDestroy() {}

  public ngOnInit() {
    this.model = new ProjectNavigationModel();
    this.model.compositeCheckBoxValue = this.isCompositeArticleProject;

    this.model.currentModel = {
      importType: null,
      lastSelectedGroupId: this.userSettings.lastSelectedProjectGroupId,
      visibleSharedProjects: true,
      visibleHiddenProjects: true
    };

    this.projectNavigationService.loadCurrentProjectGroup(this.model);
  }

  public updateSubmitEnabled() {
    this.submitEnabled = !this.model.selectedProjectGroups.isEmpty() || !this.model.selectedProjects.isEmpty();
  }

  public requestMultipleQuote() {
    const selectedProjects: ProjectHeadVO[] = this.model.selectedProjects.values();
    const projectGroupName: string = selectedProjects[0].projectGroup.groupName;
    const multipleQuoteData: MultipleQuoteRequestData = new MultipleQuoteRequestData(projectGroupName, selectedProjects);

    this.finish.emit();
    this.projectComponentPresenter.openProjectRequestApprovalDialog(multipleQuoteData);
  }

  public cancel() {
    this.finish.emit();
  }
}
